import React from 'react';
import ReactDOM from 'react-dom';
import App from './app';
import store from './store'
import { Provider } from 'react-redux'
import TagManager from 'react-gtm-module'
import gtmOptions from './services/google_tag_manager'

const tagManagerArgs = {
    gtmId: gtmOptions.gtm_id
}
 
TagManager.initialize(tagManagerArgs)

ReactDOM.render(<Provider store={store}><App /></Provider>, document.getElementById('root'));